import { render } from "./FormPhotoDocumentAndLicenceFile.vue?vue&type=template&id=7cda4350"
import script from "./FormPhotoDocumentAndLicenceFile.vue?vue&type=script&lang=js"
export * from "./FormPhotoDocumentAndLicenceFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__